app.formValidation = (function () {
  'use strict';

  let validationService = new aspnetValidation.ValidationService();

  function initRequiredRadioButtons() {
    document
      .querySelectorAll('[data-val-requiredradio]:not(.is-initialized)')
      .forEach((element) => {
        const inputName = element.getAttribute('name');
        const errorMessage = element.getAttribute('data-val-requiredradio');

        element.form
          .querySelectorAll('[name="' + inputName + '"]')
          .forEach((radio) => {
            radio.setAttribute('data-val', 'true');
            radio.setAttribute('data-val-requiredradio', errorMessage);
            radio.classList.add('is-initialized');
          });
      });
  }

  function init() {
    // mustbetrue validation (checkbox)
    validationService.addProvider('mustbetrue', (value, element, params) => {
      return element.checked;
    });

    // requiredradio validation (radio buttons)
    validationService.addProvider('requiredradio', (value, element, params) => {
      const inputName = element.getAttribute('name');
      const checkedOption = element.form.querySelector(
        '[name="' + inputName + '"]:checked'
      );
      if (checkedOption !== null) {
        element.form
          .querySelectorAll('[name="' + inputName + '"]')
          .forEach((radio) => {
            radio.classList.remove('input-validation-error');
            radio.classList.add('input-validation-valid');
          });

        return true;
      }

      element.form
        .querySelectorAll('[name="' + inputName + '"]')
        .forEach((radio) => {
          radio.classList.remove('input-validation-valid');
          radio.classList.add('input-validation-error');
        });
      return false;
    });

    initRequiredRadioButtons();
  }

  // Expose public functions and variables
  return {
    init: init,
    initRequiredRadioButtons: initRequiredRadioButtons,
    validationService: validationService,
  };
})();

app.formValidation.init();
